<template>
  <div class="new_home_div">
    <!-- 博览会临时 -->
    <div v-if="false">
      <img
        src="https://image.kilimall.com/seller/bj_zfblh_x2.jpg"
        fluid
        alt="Responsive image"
      >
    </div>

    <div>
      <!-- 广告图片 -->
      <div :class="[$style.branner_div]">
        <img
          :src="img_url.branner"
          class="img-fluid"
          alt="Responsive image"
        >
        <div :class="[$style.pay_branner_div]" />
        <div :class="[$style.branner_div_content]">
          <div
            class="branner_div_title"
            :class="[$style.branner_div_title]"
          >
            {{ $t('home.bannerTitle') }}
          </div>
          <div :class="[$style.branner_div_desc]">
            {{ $t('home.bannerSubtitle') }}
          </div>
          <div
            class="branner_div_button_div"
            :class="[$style.branner_div_button_div]"
          >
            <div
              :class="[$style.branner_play_button]"
              @click="fn_register"
            >
              {{ $t('home.registerNow') }}
            </div>
          </div>
        </div>
        <div
          v-if="false"
          :class="[$style.vedio_btn_div]"
          @click="pay_vedio_fn"
        >
          <!-- vedio播放 -->
          <div
            v-show="is_vedio_play"
            :class="[$style.vedio_pay_item]"
          >
            <video
              :id="vedio_id"
              class="video-js"
            >
              <source
                src="https://image.kilimall.cn/kilimall.mp4"
                type="video/mp4"
              >
            </video>
          </div>
          <img
            :class="[$style.vedio_btn_img]"
            :src="img_url.vedio"
            @click="vedioPauseClick"
          >
        </div>
      </div>
    </div>

    <!-- 地图 -->
    <div
      class="map_div"
      :class="[$style.map_div]"
    >
      <div :class="[$style.map_h1_title]">
        {{ $t('home.market') }}
      </div>
      <img
        :class="[$style.map_img]"
        :src="img_url.map"
      >
      <div :class="[$style.map_desc_div]">
        <div
          class="map_content_one"
          :class="[$style.map_content, $style.map_content_one]"
        >
          <div :class="[$style.map_title]">
            {{ $t('home.consumer') }}
          </div>
          <div :class="[$style.map_info_div]">
            <div class="map-introduce">
              <div class="introduce-item">
                <div :class="[$style.map_number_color]">
                  {{ $t('home.internet') }}
                </div>
                <div class="introduce-text">
                  {{ $t('home.internetUser') }}
                </div>
              </div>
              <div class="introduce-item">
                <div :class="[$style.map_number_color]">
                  {{ $t('home.dollars') }}
                </div>
                <div class="introduce-text width-en">
                  {{ $t('home.dollarsShare') }}
                </div>
              </div>
            </div>
          </div>
          <p :class="[$style.map_desc]">
            {{ $t('home.marketIntroduce') }}
          </p>
        </div>
        <div :class="[$style.clear_fix_div]" />
        <div
          class="map_content_two"
          :class="[$style.map_content, $style.map_content_two]"
        >
          <div :class="[$style.map_title]">
            {{ $t('home.platform') }}
          </div>
          <div :class="[$style.map_info_div, $style.map_info_max_width]">
            <div class="map-introduce">
              <div class="introduce-item width-2">
                <div :class="[$style.map_number_color]">
                  300%
                </div>
                <div class="introduce-text">
                  {{ $t('home.monthlySales') }}
                </div>
              </div>
              <div class="introduce-item width-3">
                <div :class="[$style.map_number_color]">
                  60%
                </div>
                <div class="introduce-text">
                  {{ $t('home.rate') }}
                </div>
              </div>
              <div class="introduce-item">
                <div :class="[$style.map_number_color]">
                  30USD
                </div>
                <div
                  class="introduce-text"
                  style="width: 200px"
                >
                  {{ $t('home.orderAmount') }}
                </div>
              </div>
            </div>
          </div>
          <p :class="[$style.map_desc]">
            {{ $t('home.development') }}
          </p>
        </div>
      </div>
    </div>
    <!-- TODO 暂不展示【合作伙伴、荣誉资质】板块 -->
    <!-- <div :class="[$style.brand_div]">
      <div :class="[$style.container]">
        <h3 :class="[$style.container_title]">合作伙伴</h3>
        <div :class="[$style.brand_img_div]">
          <img
            :class="[$style.brand_img]"
            :key="key"
            v-for="(item, key) in picSrc"
            @click="changeText(item, key)"
            :src="item.src"
            alt="image slot"
          />
        </div>
      </div>
    </div> -->
    <!-- 荣誉资质 -->
    <!-- <div :class="[$style.honor_div]">
      <div :class="[$style.container]">
        <h3 :class="[$style.container_title]">荣誉资质</h3>
        <div :class="[$style.honor_info_div]">
          <Row :gutter="20">
            <Col span="12">
              <div :class="[$style.honor_info_item]">
                <div :class="[$style.honor_item_img_div]">
                  <img
                    :class="[$style.honor_item_img]"
                    :src="img_url.honor_left"
                  />
                </div>
                <div :class="[$style.honor_item_title]">
                  何报翔副省长为网上中非经贸博览会授牌
                </div>
                <p :class="[$style.honor_item_desc]">
                  2019年6月26日，《中非经贸合作案例方案集》新书首发暨“网上中非经贸博览会”上线启动仪式在长沙举行。
                  以中英法三种语言推出的《中非经贸合作案例方案集》，
                  是践行习近平总书记谈及发展中非关系时提出的“授人以渔”重要论述的创新之作。
                  同步上线的网上中非经贸博览会平台，是一个集博览会官网、展览实况、经贸撮合为一体的新型国际化数字化平台。
                </p>
              </div>
            </Col>
            <Col span="12">
              <div :class="[$style.honor_info_item]">
                <div :class="[$style.honor_item_img_div]">
                  <img
                    :class="[$style.honor_item_img]"
                    :src="img_url.honor_right"
                  />
                </div>
                <div :class="[$style.honor_item_title]">
                  Kilimall 与湖南大学经济与贸易学院合作授牌仪式
                </div>
                <p :class="[$style.honor_item_desc]">
                  双方就如何加强校企合作，提高应用型大学服务、社会服务地方经济建设能力，
                  加快企业专业紧缺人才培养，主要是经济与贸易专业的人才培养方案，以及企业员工的职业培训等方面进行了深度的交流并达成了共识。
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div> -->
    <!-- kilimall的优势 -->
    <div :class="[$style.superiority_div]">
      <div :class="[$style.container]">
        <h3 :class="[$style.superiority_title]">
          {{ $t('home.advantage') }}
        </h3>
        <div :class="[$style.superiority_list]">
          <Row>
            <Col
              v-for="(item, index) in superiority_datas"
              :key="index"
              :class="[$style.padding_clear]"
              span="8"
            >
              <div
                :class="[$style.superiority_item]"
                @mousemove="superiority_mome_index = index"
                @mouseout="superiority_mome_index = -1"
              >
                <img
                  :class="[$style.superiority_img]"
                  :src="item.img_url"
                >
                <div
                  :class="[
                    $style.superiority_item_info,
                    superiority_mome_index === index
                      ? $style.move_opacity
                      : $style.default_opacity
                  ]"
                />
                <div :class="[$style.superiority_item_info]">
                  <div :class="[$style.superiority_item_info_desc]">
                    <img
                      :class="[$style.superiority_icon_img]"
                      :src="item.img_icon_url"
                    >
                    <div :class="[$style.superiority_item_title]">
                      {{ $t(item.title) }}
                    </div>
                    <p :class="[$style.superiority_item_info_p]">
                      {{ $t(item.desc) }}
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <!-- 开店四步 -->
    <div :class="[$style.honor_div]">
      <div :class="[$style.container]">
        <h3 :class="[$style.container_title]">
          {{ $t('home.join') }}
        </h3>
        <div :class="[$style.step_div]">
          <Row class="justify-content-md-center">
            <Col
              v-for="(item, index) in step_datas"
              :key="index"
              :class="[$style.step_margin]"
              span="6"
            >
              <div :class="[$style.step_item]">
                <span :class="[$style.step_icon]">{{ item.index }}</span>
                <div :class="[$style.step_title]">
                  {{ $t(item.title) }}
                </div>
                <div :class="[$style.step_desc]">
                  {{ $t(item.desc) }}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <!-- 立即入驻 -->
      <div :class="[$style.submit_container]">
        <div :class="[$style.submit_div]">
          <div :class="[$style.container_title, $style.color_white]">
            {{ $t('home.bottomTitle') }}
          </div>
          <div
            :class="[$style.submit_btn]"
            @click="fn_register"
          >
            {{ $t('home.registerNow') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import Video from 'video.js'

import Vedio from '@/assets/img/new_home/vedio.png'
import VedioPlayIcon from '@/assets/img/new_home/vedio_play_icon.png'
import CheckIcon from '@/assets/img/new_home/check_icon.png'
import ImgBrannerUrl from '@/assets/img/new_home/branner.jpg'
import MapUrl from '@/assets/img/new_home/map.png'
import HonorLeft from '@/assets/img/new_home/honor1.png'
import HonorRight from '@/assets/img/new_home/honor2.png'
import SuperiorityOne from '@/assets/img/new_home/superiority1.png'
import SuperiorityTwo from '@/assets/img/new_home/superiority2.png'
import SuperiorityThree from '@/assets/img/new_home/superiority3.png'
import SuperiorityIconOne from '@/assets/img/new_home/superiority_icon1.png'
import SuperiorityIconTwo from '@/assets/img/new_home/superiority_icon2.png'
import SuperiorityIconThree from '@/assets/img/new_home/superiority_icon3.png'
import Ellipsis from '@/assets/img/new_home/ellipsis.png'

import SWTBranner from '@/assets/img/new_home/swt_branner.jpg'

import brand1 from '@/assets/img/new_home/ic_konka_logo_normal.png'
import brand2 from '@/assets/img/new_home/ic_gongshang_logo_normal.png'
import brand3 from '@/assets/img/new_home/ic_huawei_logo_normal.png'
import brand4 from '@/assets/img/new_home/ic_standard_logo_normal.png'
import brand5 from '@/assets/img/new_home/ic_pingpong_logo_normal.png'
import brand6 from '@/assets/img/new_home/ic_cec_logo_normal.png'
import brand7 from '@/assets/img/new_home/ic_kuajingpai_logo_normal.png'
import brand8 from '@/assets/img/new_home/ic_transsion_logo_normal.png'
import brand9 from '@/assets/img/new_home/ic_dianxiaomi_logo_normal.png'
import brand10 from '@/assets/img/new_home/ic_mangguodianzhang_logo_normal.png'
export default {
  data() {
    return {
      video_fn: Video,
      is_vedio_play: false,
      vedio_obj: null,
      vedio_id: '',
      img_url: {
        swt_branner: SWTBranner,
        branner: ImgBrannerUrl,
        map: MapUrl,
        honor_left: HonorLeft,
        honor_right: HonorRight,
        ellipsis: Ellipsis,
        vedio: Vedio,
        check_icon: CheckIcon,
        vedio_play_icon: VedioPlayIcon
      },
      picSrc: [
        { src: brand1 },
        { src: brand2 },
        { src: brand3 },
        { src: brand4 },
        { src: brand5 },
        { src: brand6 },
        { src: brand7 },
        { src: brand8 },
        { src: brand9 },
        { src: brand10 }
      ],
      superiority_mome_index: -1,
      superiority_datas: [
        {
          img_url: SuperiorityOne,
          img_icon_url: SuperiorityIconOne,
          title: 'home.advantageTitle1',
          desc: 'home.advantageContent1'
        },
        {
          img_url: SuperiorityTwo,
          img_icon_url: SuperiorityIconTwo,
          title: 'home.advantageTitle2',
          desc: 'home.advantageContent2'
        },
        {
          img_url: SuperiorityThree,
          img_icon_url: SuperiorityIconThree,
          title: 'home.advantageTitle3',
          desc: 'home.advantageContent3'
        }
      ],
      step_datas: [
        {
          index: 1,
          title: 'home.registerTitle1',
          desc: 'home.registerText1'
        },
        {
          index: 2,
          title: 'home.registerTitle2',
          desc: 'home.registerText2'
        },
        {
          index: 3,
          title: 'home.registerTitle3',
          desc: 'home.registerText3'
        },
        {
          index: 4,
          title: 'home.registerTitle4',
          desc: 'home.registerText4'
        }
      ],
      isPlaying: false // 是否是播放状态
    }
  },
  mounted() {
    // 隐藏视频 产品需求 2024/05/11
    // this.vedio_id = `vid_${new Date().getTime()}`
    // window.Video = Video
    // this.$nextTick(() => {
    //   this.initVideo()
    // })
  },
  methods: {
    randomNum(num1, num2) {
      return (Math.random() * (num2 - num1) + num1).toFixed()
    },

    pay_vedio_fn() {
      this.is_vedio_play = true
      if (this.vedio_obj && !this.isPlaying) {
        this.isPlaying = true
        this.vedio_obj.play()
      }
    },

    // 暂停视频
    vedioPauseClick() {
      if (this.isPlaying) {
        this.vedio_obj.pause()
        this.isPlaying = false
      }
    },

    initVideo() {
      // 初始化视频方法
      this.vedio_obj = this.video_fn(this.vedio_id, {
        controls: true,
        preload: 'metadata',
        width: '100%',
        height: '100%'
      })
    },

    fn_register() {
      this.$router.push('/create-seller-account/entry')
    }
  }
}
</script>

<style module>
.branner_div {
  position: relative;
  margin-bottom: 40px;
  margin-top: -2px;
}
.branner_div_content {
  position: absolute;
  top: 28%;
  left: 8%;
  z-index: 10;
}
.pay_branner_div {
  background-color: #000000;
  opacity: 0.6;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 9;
}
.vedio_btn_div {
  width: 40%;
  position: absolute;
  top: 20%;
  right: 5%;
  z-index: 10;
  cursor: pointer;
}
.vedio_pay_item {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10;
}
.close_vedio_icon {
  position: absolute;
  right: 20px;
  top: 4px;
  font-size: 0.2rem;
  color: white;
  cursor: pointer;
}
.vedio_btn_img {
  width: 100%;
  height: 100%;
}
.branner_div_title {
  color: white;
  font-weight: bold;
  font-size: 0.28rem;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}
.branner_div_desc {
  margin-top: 2%;
  color: white;
  font-weight: 400;
  font-size: 19.2px;
}
.branner_div_button_div {
  margin-top: 14%;
  cursor: pointer;
  display: none;
}
.branner_button {
  padding: 0.08rem 0.14rem;
  color: white;
  font-weight: 600;
  font-size: 0.08rem;
  background-color: #f87622;
  display: inline-block;
  border-radius: 4px;
  cursor: pointer;
}
.branner_play_button {
  padding: 0.13rem 0.38rem;
  color: white;
  font-weight: 600;
  font-size: 0.13rem;
  background-color: #f87622;
  display: inline-block;
  border-radius: 4px;
  cursor: pointer;
}
.button_pay_icon {
  width: 16px;
  height: 16px;
  margin-right: 2px;
  display: inline-block;
  vertical-align: middle;
}
.vedio_span {
  vertical-align: middle;
}
.branner_submit_button {
  padding: 0.8rem 0.2rem;
  color: #f87622;
  margin-left: 20px;
  font-weight: 600;
  font-size: 0.8rem;
  background-color: white;
  display: inline-block;
  border-radius: 4px;
}
.map_div {
  margin-top: 20px;
  background-color: white;
  padding-bottom: 30px;
  position: relative;
  text-align: center;
  min-height: 1300px;
}
.map_h1_title {
  font-size: 41.6px;
  font-weight: 600;
  margin: 40px;
}
.map_img {
  max-width: 1200px;
  width: 70%;
  margin-left: -20%;
}
.map_content {
  width: 90%;
  /* max-width: 684px; */
  max-width: 750px;
  min-height: 276px;
  overflow: hidden;
  background-color: white;
  box-shadow: 0px 10px 20px 0px rgba(221, 223, 228, 1);
  border-radius: 8px;
  padding: 30px 20px;
  box-sizing: border-box;
  text-align: left;
}
.map_content_one {
  float: right;
  margin-top: 6%;
  margin-right: 5%;
}
.map_content_two {
  margin-left: 5%;
  margin-top: 10%;
}
.clear_fix_div {
  clear: both;
}
.map_title {
  color: #23292e;
  font-weight: 100;
  font-size: 35.2px;
}
.map_desc_div {
  width: 100%;
  max-width: 1200px;
  position: absolute;
  top: 10%;
  left: 0;
  bottom: 0;
  right: 0;
  margin-left: -600px;
  margin: auto;
}
.map_info_div {
  margin-top: 10px;
  min-width: 326px;
  width: 46%;
  font-weight: 400;
  font-size: 0.12rem;
}
.map_info_max_width {
  width: 100%;
}
.map_number_color {
  color: #f87622;
  margin: 5px 0;
  font-size: 28.8px;
}
.map_desc {
  font-size: 16px;
  margin: 30px 0 16px 0;
  line-height: 30px;
}
.base_background_white {
  background-color: white;
}
.brand_div {
  background-color: #f6f6f6;
  padding: 50px 0;
}
.container {
  max-width: 1200px;
  width: 90%;
  margin: 0 auto;
  text-align: center;
}
.container_title {
  font-size: 41.6px;
  font-weight: 600;
  text-align: center;
  padding: 0 10px;
}
.brand_img_div {
  margin-top: 20px;
}
.brand_img {
  max-width: 200px;
  min-width: 150px;
  width: 16%;
  margin: 2%;
}
.honor_div {
  padding: 50px 0;
  background-color: white;
  position: relative;
}
.honor_info_div {
  margin-top: 50px;
}
.honor_info_item {
  width: 100%;
  margin: 0 5%;
  min-width: 280px;
}
.honor_item_img_div {
  width: 100%;
  overflow: hidden;
}
.honor_item_img {
  width: 96%;
}
.honor_item_title {
  color: #f87622;
  font-weight: 400;
  line-height: 46px;
  font-size: 0.16rem;
}
.honor_item_desc {
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  font-size: 0.14rem;
}
.superiority_div {
  background-color: #32302f;
  padding-top: 50px;
  line-height: 0.9;
}
.superiority_title {
  color: #f87622;
  font-size: 41.6px;
  line-height: 1.2;
  font-weight: 600;
  text-align: center;
}
.superiority_list {
  margin: 50px 0;
  width: 100%;
  overflow: hidden;
}
.superiority_item {
  width: 100%;
  position: relative;
  cursor: pointer;
  min-width: 280px;
}
.superiority_img {
  width: 100%;
}
.superiority_item_info {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
}
.superiority_item_info_desc {
  margin: 30% 0;
  color: white;
  font-weight: 600;
  font-size: 0.16rem;
}
.superiority_icon_img {
  width: 64px;
  height: 64px;
  display: inline-block;
  margin-bottom: 16%;
}
.superiority_item_title {
  font-size: 25.6px;
  line-height: 1.35;
}
.superiority_item_info_p {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width: 80%;
  text-align: left;
  margin: 0 auto;
  margin-top: 8%;
  display: block;
}
.default_opacity {
  background-color: #000000;
  opacity: 0.6;
}
.move_opacity {
  background-color: #f87622;
  opacity: 0.6;
}
.padding_clear {
  padding: 0;
}
.step_icon {
  background-color: #f87622;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  display: block;
  border-radius: 70px;
  color: white;
  font-size: 32px;
  font-weight: 400;
}
.step_title {
  color: #f87622;
  font-size: 19.2px;
  font-weight: 600;
  margin-top: 30px;
  border-top: 2px solid #d8d8d8;
  padding-top: 20px;
}
.step_desc {
  color: #999999;
  font-size: 12.8px;
  font-weight: 400;
  margin-top: 10px;
}
.step_div {
  margin-top: 30px;
  margin-bottom: 150px;
}
.step_item {
  background: url('@/assets/img/new_home/ellipsis.png') no-repeat;
  background-position-x: 100%;
  background-position-y: 30%;
  background-size: 43px 8px;
  text-align: left;
  margin-top: 20px;
}
.step_margin:nth-child(1) {
  padding-right: 7.5%;
}
.step_margin:nth-child(4) {
  padding-left: 7.5%;
}
.step_margin:nth-child(2) {
  padding-left: 2.5%;
  padding-right: 5%;
}
.step_margin:nth-child(3) {
  padding-right: 2.5%;
  padding-left: 5%;
}
.submit_container {
  position: absolute;
  width: 100%;
  bottom: -170px;
  left: 0;
  z-index: 333;
}
.submit_div {
  margin: 0 auto;
  width: 90%;
  max-width: 1200px;
  border-radius: 16px;
  overflow: hidden;
  background: url('@/assets/img/new_home/form_bj.png') no-repeat;
  background-size: 105% 100%;
  background-position: center;
  min-height: 300px;
  padding-top: 50px;
  box-sizing: border-box;
}
.color_white {
  color: white;
  margin-top: 10px;
}
.submit_memo {
  width: 54%;
  margin: 0 auto;
  font-size: 0.08rem;
  line-height: 0.15rem;
  margin-top: 10px;
}
.submit_btn {
  box-shadow: 0px 11px 23px 0px rgba(114, 0, 0, 0.34);
  background-color: white;
  border-radius: 36px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 0.16rem;
  width: 268px;
  font-weight: 600;
  margin: 20px auto;
  cursor: pointer;
}
.check_icon {
  width: 14px;
  display: inline-block;
  margin: 0 4px;
  vertical-align: middle;
}
</style>

<style>
.new_home_div {
  color: #212529;
}
.new_home_div >>> .modal-header {
  border: none !important;
  padding: 0 0.05rem !important;
}
.new_home_div >>> .modal-footer {
  display: none;
}
.new_home_div >>> .modal-body {
  padding: 0rem 0.2rem 0.1rem !important;
}
</style>

<style lang="less">
.video-js {
  width: 100%;
  height: 100%;
}
@media (min-width: 1520px) {
  .branner_div_title {
    font-size: 44.8px;
  }
}
@media (max-width: 1520px) {
  .branner_div_title {
    font-size: 40px;
  }
}
@media (min-width: 768px) {
  .new_footer {
    display: block;
  }
  .new_footer_padding {
    display: none;
  }
  .map_content_two {
    margin-left: 20%;
  }
  .map_content_one {
    margin-right: 0;
  }
  .map_div {
    min-height: 950px;
  }
  // .branner_div_title {
  //   font-size: 44.8px;
  // }
  .branner_div_button_div {
    display: block;
  }
}
</style>

<style lang="less" scoped>
/deep/ #modal-2 {
  .modal-dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) !important;
    .modal-content {
      width: 600px;
    }
    .modal-footer {
      display: none;
    }
  }
}
/deep/ .ivu-col-span-12 {
  display: flex;
  justify-content: center;
}
/deep/.ivu-row {
  margin: 0 -15px 0 -15px;
}
.img-fluid {
  width: 100%;
  height: 100%;
  vertical-align: middle;
  background-repeat: no-repeat;
  border-style: none;
  // margin-top: -2px;
}
.map-introduce {
  display: flex;
  .introduce-item {
    width: 1.63rem;
    margin-left: 5px;
    .introduce-text {
      font-size: 16px;
    }
  }
}
.width-2 {
  width: 288px !important;
}
.width-3 {
  width: 1.84rem !important;
}
.width-en {
  width: 200px;
}
</style>
